/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import ContentCarousel from '../ContentCarousel';
import Cards from '../Cards/Default';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const SETTINGS = {
  dots: true,
  infinite: true,
  autoplay: true,
  speed: 1000,
  autoplaySpeed: 3000,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const Carrossel = ({ rows, onClick, color }) => (
  <ContentCarousel>
    <Slider {...SETTINGS}>
      {rows.suggestedActions.map((response) => (
        <Cards
          color={color}
          title={response.title}
          description={response.description}
          image={response.img}
          button={{
            status: !!response.button,
            title: response.button ? response.button.stringValue : '',
            redirectUrl: response.button
              ? response.redirect_uri.stringValue
              : '',
          }}
          onClick={() => onClick(response.event)}
        />
      ))}
    </Slider>
  </ContentCarousel>
);

Carrossel.propTypes = {
  rows: PropTypes.object.isRequired,
  color: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Carrossel;
